export const WORKFLOW_IMPORT_DIALOG_SET_OPEN =
  'WORKFLOW_IMPORT_DIALOG_SET_OPEN';

export function openWorkflowImportDialog() {
  return {
    type: WORKFLOW_IMPORT_DIALOG_SET_OPEN,
    payload: {
      isOpen: true,
    },
  };
}

export function closeWorkflowImportDialog() {
  return {
    type: WORKFLOW_IMPORT_DIALOG_SET_OPEN,
    payload: {
      isOpen: false,
    },
  };
}
